import { useState } from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';

type usePasswordRestrictConfirmationReturnType = {
  confirmationModalOpen: boolean;
  closeConfirmationModal: () => void;
  setFieldValue: (value: boolean) => void;
  onChangeCheckedFeature: (checked: boolean) => void;
};

export function usePasswordRestrictConfirmation(
  name: string
): usePasswordRestrictConfirmationReturnType {
  const { setValue } = useFormContext();
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const closeConfirmationModal = (): void => {
    setConfirmationModalOpen(false);
  };

  const setFieldValue = (value: boolean): void => {
    setValue(name, value);
    closeConfirmationModal();
  };

  const onChangeCheckedFeature = (checked): void => {
    if (checked) {
      setFieldValue(false);
      setConfirmationModalOpen(true);
    }
  };

  return {
    confirmationModalOpen,
    closeConfirmationModal,
    setFieldValue,
    onChangeCheckedFeature,
  };
}
